// Singleton service to fetch file data once per filename and share updates with subscribers
const entries = new Map();

function fetchFor(file) {
  const entry = entries.get(file);
  if (!entry) return;
  fetch(`/api/file?name=${encodeURIComponent(file)}`)
    .then(res => res.json())
    .then(data => {
      entry.data = data;
      entry.subs.forEach(cb => cb(data));
    })
    .catch(err => {
      // notify subscribers with null on error
      console.warn('fileDataService fetch error', file, err);
      entry.subs.forEach(cb => cb(null));
    });
}

export function subscribe(file, cb) {
  if (!file) return () => {};
  let entry = entries.get(file);
  if (!entry) {
    entry = { data: null, subs: new Set(), intervalId: null };
    entries.set(file, entry);
  }

  entry.subs.add(cb);

  // if we already have data, send it immediately
  if (entry.data) cb(entry.data);

  // start periodic fetch if not already started
  if (!entry.intervalId) {
    // initial fetch
    fetchFor(file);
    entry.intervalId = setInterval(() => fetchFor(file), 60000);
  }

  // return unsubscribe
  return () => {
    const e = entries.get(file);
    if (!e) return;
    e.subs.delete(cb);
    if (e.subs.size === 0) {
      clearInterval(e.intervalId);
      entries.delete(file);
    }
  };
}

export function getCached(file) {
  const e = entries.get(file);
  return e ? e.data : null;
}

// Force an immediate fetch for a file. If there is an entry with subscribers
// we simply call the fetch routine. If there is no entry, create a temporary
// entry, fetch once and remove the temporary entry shortly after so we don't
// leave unused state lying around.
export function refresh(file) {
  if (!file) return;
  const e = entries.get(file);
  if (e) {
    fetchFor(file);
    return;
  }
  const tmp = { data: null, subs: new Set(), intervalId: null };
  entries.set(file, tmp);
  fetchFor(file);
  setTimeout(() => {
    const cur = entries.get(file);
    if (cur && cur.subs.size === 0 && cur.intervalId === null) entries.delete(file);
  }, 1000);
}
